<div class="px-3 pt-3">
  <a class="nav-link refresh-icon p-1 mr-4" (click)="refreshList()">
    <i class="now-ui-icons loader_refresh"></i>
  </a>
  @if (!preloading) {
    <a class="nav-link refresh-icon p-1 mr-2" (click)="preload($event)">
      <i class="now-ui-icons arrows-1_cloud-upload-94"></i>
    </a>
  }

  <h4 class="mb-0">{{ 'BO_MY_WORK' | translate }}</h4>


</div>

@if (workOrders$ | async; as workOrders) {
  @if (workOrders.length) {
    <div class="">
      <ul>
        @for (w of workOrders; track w; let i = $index) {
          @if (w.workItemId === currentId) {
            <li class="active" [class.done]="w.action">
              {{w.label}}
              @if (w.note) {
                <span class="note-icon text-info mr-2"><i class="now-ui-icons ui-2_chat-round"></i></span>
              }
            </li>
          }
          @if (w.workItemId !== currentId) {
            <li (click)="handleClick(w)" [class.done]="w.action">
              {{w.label}}
              @if (w.note) {
                <span class="note-icon text-info mr-2"><i class="now-ui-icons ui-2_chat-round"></i></span>
              }
            </li>
          }
        }
      </ul>
    </div>
  } @else {
    <div>
      <p class="mt-4"></p>
    </div>
  }
} @else {
  <div class="p-3">
    <span class="loading">
      <span class="dot">.</span>
      <span class="dot">.</span>
      <span class="dot">.</span>
    </span>
  </div>
}
@if (nextWorkOrder$ | async) {
}



